import React from 'react';
import './Section1.css';

function Section1() {
  const handleClick = () => {
    window.open("https://donor.southtexasblood.org/donor/store/preview?utm_source=double_my_impact&utm_medium=landing_page&utm_campaign=twa_dontate&utm_content=stb&t",
     "_blan");
  };
  return (
    <>
    
    <div className="cancer-container">
    <div className='kids-overlay'>
        <div className="main-title">Support <br/>San Antonio Seniors</div>
            <div className="main-body"><span className="bold-text">Double your impact,</span> and transform <br/>
             100 Reward Store points into meals <br/>
            for seniors!</div>
        
        <button className="donate-btn1" onClick={handleClick}>Donate points</button>
    </div>
    </div>
  </>
  )
}

export default Section1